/** Prerender / Cache Components uyumlu monotonik zaman (süre ölçümü ve process-içi TTL). */
export function monotonicNow(): number {
  return typeof performance !== 'undefined' ? performance.now() : 0;
}

let deterministicSeq = 0;

/** Prerender-safe benzersiz id (Math.random / crypto.randomUUID yerine). */
export function nextDeterministicId(prefix = 'id'): string {
  deterministicSeq += 1;
  return `${prefix}-${deterministicSeq}`;
}
